// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__5h_GZ","amount":"Amount_amount__2t5-Q","tip":"Amount_tip__33YDD","tipHeader":"Amount_tipHeader__3kQ38","tipsWrap":"Amount_tipsWrap__1nxMR"};